import { cn } from '~/lib/utils';
import addReactionIcon from '~/landing_page/Assets/add_reaction.svg';
import avatar1 from '~/landing_page/Assets/Avatar1.png';
import styles from './WidgetCard.module.css';

export interface SlackCardProps {
  className?: string;
  sender?: string;
  time?: string;
  message?: string;
}

export const SlackCard = ({
  className,
  sender = 'Guri',
  time = '8:29 PM',
  message = 'Hey Beka, are you presenting the sprint review today? Does the deck cover the auth delays?',
}: SlackCardProps) => {
  return (
    <div className={cn(styles.card, className)}>
      <div className={styles.row}>
        <img
          src={avatar1}
          alt={sender}
          style={{
            width: 28,
            height: 28,
            borderRadius: 'var(--radius-full)',
            flexShrink: 0,
            objectFit: 'cover',
          }}
        />
        <div className={styles.body}>
          <div className={styles.header}>
            <span className={styles.headerTitle}>{sender}</span>
            <span className={styles.textHint}>{time}</span>
          </div>
          <p className={cn(styles.text, styles.textClamp3)}>{message}</p>
          <div className={styles.reactionBar}>
            <span className={styles.reaction}>
              <span className={styles.reactionEmoji}>👀</span> 1
            </span>
            <span className={styles.reaction}>
              <img src={addReactionIcon} alt="" className={styles.reactionIcon} />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

SlackCard.displayName = 'SlackCard';
